import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider as ReactRouterProvider } from 'react-router-dom';

import { WorkspaceSkeleton } from '@/app/layouts';

import { routes } from './routes';

function RouteLoadingFallback() {
  return <WorkspaceSkeleton />;
}

/**
 * Browser router instance configured with application routes.
 * Created outside component to avoid recreation on re-renders.
 */
const router = createBrowserRouter(routes);

/**
 * Provides routing context to the application.
 * Wraps routes in Suspense for lazy-loaded page components.
 */
export function RouterProvider() {
  return (
    <Suspense fallback={<RouteLoadingFallback />}>
      <ReactRouterProvider router={router} />
    </Suspense>
  );
}
